export const STORE_CURRENT_COURSE = 'STORE_CURRENT_COURSE'
export const STORE_LIST_COURSES = 'STORE_LIST_COURSES'
export const STORE_COURSE_STRUCTURE = 'STORE_COURSE_STRUCTURE'
export const RESET_CURRENT_COURSE = 'RESET_CURRENT_COURSE'
export const RESET_CURRENT_COURSE_CONTENT = 'RESET_CURRENT_COURSE_CONTENT'
export const ADD_LEAF_TO_STRUCTURE = 'ADD_LEAF_TO_STRUCTURE'
export const ADD_LEAFS_INTO_STRUCTURE = 'ADD_LEAFS_INTO_STRUCTURE'
export const REMOVE_LEAF_TO_STRUCTURE = 'REMOVE_LEAF_TO_STRUCTURE'
export const RENAME_GROUP = 'RENAME_GROUP'
export const ADD_GROUP_TO_STRUCTURE = 'ADD_GROUP_TO_STRUCTURE'
export const REMOVE_GROUP_OF_STRUCTURE = 'REMOVE_GROUP_OF_STRUCTURE'
export const UPDATE_CONTENT_ORDER = 'UPDATE_CONTENT_ORDER'
export const ADD_FILE_CURRENT_COURSE = 'ADD_FILE_CURRENT_COURSE'
export const REMOVE_FILE_CURRENT_COURSE = 'REMOVE_FILE_CURRENT_COURSE'
export const ADD_PASS_TO_COURSE_PASSES = 'ADD_PASS_TO_COURSE_PASSES'
export const REMOVE_PASS_FROM_COURSE_PASSES = 'REMOVE_PASS_FROM_COURSE_PASSES'
export const SAVE_HUNDRED_COURSES = 'SAVE_HUNDRED_COURSES'
export const STORE_CURRENT_COURSE_FILES = 'STORE_CURRENT_COURSE_FILES'
export const CHANGE_FILE_IN_COURSE = 'CHANGE_FILE_IN_COURSE'
export const RESET_FILES_IN_COURSE = 'RESET_FILES_IN_COURSE'
